import AccountButton from "../account_button/AccountButton";
import { Container, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <Segment>
      <Container style={{ display: "flex", alignItems: "center" }}>
        <Link to={"/"} style={{ flex: 1 }}>
          <h1>GeoDL</h1>
        </Link>
        <AccountButton></AccountButton>
      </Container>
    </Segment>
  );
};

export default Header;
